import { CommonModule } from '@angular/common';
import { Component, inject, LOCALE_ID } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'abc-language-selector',
  imports: [CommonModule, FormsModule],
  templateUrl: 'language-selector.html',
})
export class LanguageSelector {
  currentLocale = inject(LOCALE_ID);

  languages = [
    { code: 'en-BE', label: 'EN' },
    { code: 'nl-BE', label: 'NL' },
  ];

  switchLanguage(targetLocale: string): void {
    if (targetLocale === this.currentLocale) {
      return;
    }
    const supportedLocales = this.languages.map((lang) => lang.code);

    if (!supportedLocales.includes(targetLocale)) {
      console.error('Unsupported locale:', targetLocale);
      return;
    }
    this.currentLocale = targetLocale;

    const pathWithoutLocale = window.location.pathname.replace(/^\/(en-BE|nl-BE)/, '') || '/';

    const { protocol, host } = window.location;
    location.replace(`${protocol}//${host}/${targetLocale}${pathWithoutLocale}`);
  }
}
